import React from 'react';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../helpers/EventEmitter';

export const withSyncDragCode = Component => {
  class WithSyncDragCode extends React.PureComponent {
    componentDidMount() {
      const { dragCode, syncType } = this.props;
      if (!dragCode) {
        return;
      }
      EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
        syncType: syncType,
        search: dragCode,
      });
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  return WithSyncDragCode;
};
